import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

// Define a service using a base URL and expected endpoints
export const voucherParticipantService = createApi({
  reducerPath: "voucherParticipantService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["voucherParticipant"],
  endpoints: (builder) => ({
    getAllVoucherParticipant: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.getAllVoucherParticipant}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },

        };
      },
    }),
    getAllVoucherParticipantBySearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.getAllVoucherParticipantBySearch}`,
          method: "POST",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    updateVoucherParticipant: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.updateVoucherParticipant}/${body.id}`,
          method: "PUT",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    deleteVoucherParticipant: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.deleteVoucherParticipant}/${body.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getVoucherParticipantById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.getVoucherParticipantById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    saveVoucherParticipant: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.saveVoucherParticipant}`,
          method: "POST",
          body: body.payload,
           headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    findAllVoucherParticipant: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.findAllVoucherParticipant}`,
          method: "GET",
           headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    bulkSaveVoucherParticipant: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.voucherParticipantController.bulkSaveVoucherParticipant}`,
          method: "POST",
          body: body.payload,
           headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});

export const {
  useGetAllVoucherParticipantMutation,
  useGetAllVoucherParticipantBySearchMutation,
  useUpdateVoucherParticipantMutation,
  useDeleteVoucherParticipantMutation,
  useGetVoucherParticipantByIdMutation,
  useSaveVoucherParticipantMutation,
  useFindAllVoucherParticipantMutation,
  useBulkSaveVoucherParticipantMutation,
} = voucherParticipantService;
